module.exports = __webpack_public_path__ + "img/xtzdh.9b13152f.jpg";